import React from "react";
import termsTranslations from "../i18n/termsTranslations";
import getCurrentLang from "../utils/getCurrentLang";

export default function Terms() {
  const lang = getCurrentLang();
  const t = termsTranslations[lang] || termsTranslations["pt"];

  return (
    <main style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", color: "#3E2723" }}>
      <h1>{t.title}</h1>
      {t.sections.map((section, index) => (
        <section key={index} style={{ marginBottom: "2rem" }}>
          <h2>{section.heading}</h2>
          {section.content.map((paragraph, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
          ))}
        </section>
      ))}
    </main>
  );
}
